const UltimasComprasProdutoController = ControllerBase.extend({
    name: "UltimasComprasProdutoController",

    ajax: function() {

        return {
            url: "/Produto/_UltimasComprasProduto",
            type: "post",
            cache: false,
            data: {
                CodigosProdutos: this.collection,
                CodigoCliente: this.orcamento.get("CodigoCliente"),
                CodigoFilial: this.orcamento.get("CodigoFilialOrcamento")
            }
        };
    },

    renderizado: function () {
        this.carregar(this.collection);
    },

    carregar: function(data) {

        this.ultimasComprasProdutoView = this.showView({
            region: {
                name: "ultimasComprasProdutoView",
                selector: "#ultima-compra-region",
                modal: this.showModal
            },
            view: {
                type: UltimasComprasProdutoView,
                args: {
                    collection: new Backbone.Collection(data)
                }
            }
        });
    }
});

window.UltimasComprasProdutoController = UltimasComprasProdutoController

export {
    UltimasComprasProdutoController
}